export default "__VITE_ASSET__be0c7262__"